module.exports = __webpack_public_path__ + "static/Lato-Black-babfe24e0bcae4a6db4c57304e21d6cc.ttf";